import config from "@config";

const currentTemplate = config.template.name || "base";

const CONFIG_JSON = require(`../${currentTemplate}/config/graphql.json`);

export default CONFIG_JSON;
